export type SingleOption = {
	sequence: string;
	accountType: string;
	billingType: string;
	category: string;
	label: string;
	url: string;
	icon: string;
	backgroundColor?: string;
};

const model: types.models.InputModel = {
	sequence: 'sequence',
	accountType: 'accountType',
	billingType: 'billingType',
	category: 'category',
	label: 'label',
	url: 'url',
	icon: 'icon',
	backgroundColor: 'backgroundColor',
};

export default model;
